// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/channel/components/modals/channel_tabs/ChannelOverviewTab.module.css';
import type {ExtendedOptionProps} from '@app/features/channel/components/modals/channel_tabs/channel_overview_tab/shared';
import * as EmojiUtils from '@app/features/expressions/utils/EmojiUtils';
import {observer} from 'mobx-react-lite';
import {components} from 'react-select';

export const RtcRegionOptionComponent = observer((props: ExtendedOptionProps) => {
	const {region, label} = props.data;
	if (!region) {
		return (
			<components.Option
				data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-option-component.components-option"
				{...props}
			>
				<span data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-option-component.span">{label}</span>
			</components.Option>
		);
	}
	const displayName = props.getRegionDisplayName(region.id, region.name);
	return (
		<components.Option
			data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-option-component.components-option--2"
			{...props}
		>
			<div
				className={styles.regionOption}
				data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-option-component.region-option"
			>
				<img
					src={EmojiUtils.getEmojiURL(region.emoji) ?? undefined}
					alt={displayName}
					className={styles.regionEmoji}
					data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-option-component.region-emoji"
				/>
				<span data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-option-component.span--2">
					{displayName}
				</span>
			</div>
		</components.Option>
	);
});
